/* ===================================================================
   FUROMA article — legacy FAQ upgrade   (U33 / 02-ux-conversion)
   -------------------------------------------------------------------
   Turns the flat FAQ markup in already-published articles into native
   <details> accordions, so a 10-question FAQ stops being 10 screens of
   scroll on mobile (73% of traffic).

   Why JavaScript, when the rest of U33 is server-side:
   the legacy FAQ exists in three different shapes across the 14 posts,
   and Liquid's `replace` is literal-string only -- it cannot tell a
   question paragraph from any other bold-led paragraph (the References
   block opens with <p><strong>Author:</strong>). Pairing questions with
   answers needs the DOM.

   CLS: the FAQ sits near the end of a 2,000-5,000 word article, far
   below the fold, so the collapse happens off-screen and does not shift
   anything the reader is looking at.

   SEO / schema: no text is added, removed, or rewritten -- nodes are
   only re-parented. Answer text stays in the DOM while collapsed, so it
   remains byte-identical to the FAQPage schema.

   Shapes handled (verified live 2026-08-27):
     1. <p><strong>Q</strong></p> + <p>A</p>      pet-safe-reed-diffuser
     2. <p><strong>Q</strong><br>A…</p>           is-peppermint-oil-safe-for-dogs
     3. <h3>Q1: …</h3> + <p>A</p>                 essential-oils-safe-for-cats-and-dogs
   Anything it does not recognise is left exactly as it is.
   =================================================================== */

(function () {
  'use strict';

  // Only prose can be an answer. Anything else between the FAQ heading and
  // the next H2 -- a product component, a table, a figure -- is separate
  // content that happens to sit there, and absorbing it into the last
  // <details> would hide it behind a collapsed question. Measured: a Browse
  // block placed before the next H2 ended up indented inside the final
  // answer, invisible until that question was expanded.
  var ANSWER_TAGS = { P: 1, UL: 1, OL: 1, BLOCKQUOTE: 1, DL: 1 };

  var root = document.querySelector('.furoma-article[data-faq-collapse="true"]');
  if (!root || root.dataset.faqUpgraded) return;

  var heading = findFaqHeading(root);
  if (!heading) return;

  var section = collectSection(heading);
  if (!section.length) return;

  // A new-style article already authored its own accordion -- leave it.
  if (section.some(function (n) { return n.tagName === 'DETAILS' || n.querySelector('details'); })) return;

  var items = parse(section);
  if (items.length < 2) return; // not a recognisable Q&A run

  render(items, heading);
  root.dataset.faqUpgraded = 'true';

  /* ---------------------------------------------------------------- */

  function findFaqHeading(scope) {
    var byId = scope.querySelector('h2#faq');
    if (byId) return byId;
    var headings = scope.querySelectorAll('h2');
    for (var i = 0; i < headings.length; i++) {
      if (/^\s*(?:\d+\.\s*)?(?:faq|frequently asked)/i.test(headings[i].textContent)) return headings[i];
    }
    return null;
  }

  // Every sibling after the FAQ heading, up to the next H2.
  function collectSection(h) {
    var out = [];
    for (var n = h.nextElementSibling; n && n.tagName !== 'H2'; n = n.nextElementSibling) out.push(n);
    return out;
  }

  // A paragraph is a question when its content is a single leading
  // <strong> -- optionally followed by <br> and the answer (shape 2).
  function questionParts(el) {
    if (el.tagName === 'H3') return { q: el, inline: null };
    if (el.tagName !== 'P') return null;

    var strong = el.firstElementChild;
    if (!strong || strong.tagName !== 'STRONG') return null;
    if (el.firstChild !== strong) return null; // text before the bold -> not a question

    var br = null;
    for (var n = strong.nextSibling; n; n = n.nextSibling) {
      if (n.nodeType === 1 && n.tagName === 'BR') { br = n; break; }
      if (n.nodeType === 3 && n.textContent.trim()) break;  // stray text -> shape 1
      if (n.nodeType === 1) break;
    }
    return { q: el, inline: br };
  }

  function parse(nodes) {
    var items = [], current = null;

    nodes.forEach(function (el) {
      var parts = questionParts(el);

      if (!parts && current && !ANSWER_TAGS[el.tagName]) {
        current = null;        // end the run; leave this node where it is
        return;
      }

      if (parts) {
        current = { source: el, strong: parts.q.tagName === 'H3' ? null : el.firstElementChild,
                    isHeading: parts.q.tagName === 'H3', inlineBr: parts.inline, answers: [] };
        items.push(current);
        return;
      }
      if (current) current.answers.push(el);
    });

    // Keep only entries that actually have an answer to reveal.
    return items.filter(function (it) { return it.answers.length || it.inlineBr; });
  }

  function render(items, heading) {
    var wrap = document.createElement('div');
    wrap.className = 'furoma-faq';

    items.forEach(function (it) {
      var details = document.createElement('details');
      var summary = document.createElement('summary');

      if (it.isHeading) {
        // <h3>Q</h3> -- move its children into the summary.
        while (it.source.firstChild) summary.appendChild(it.source.firstChild);
      } else {
        // <p><strong>Q</strong>… -- the bold run is the question.
        while (it.strong.firstChild) summary.appendChild(it.strong.firstChild);
      }
      details.appendChild(summary);

      // Shape 2: the answer trails a <br> inside the question paragraph.
      if (it.inlineBr) {
        var body = document.createElement('p');
        var node = it.inlineBr.nextSibling;
        while (node) {
          var next = node.nextSibling;
          body.appendChild(node);
          node = next;
        }
        if (body.childNodes.length) details.appendChild(body);
      }

      it.answers.forEach(function (a) { details.appendChild(a); });

      wrap.appendChild(details);
      it.source.remove();
    });

    heading.insertAdjacentElement('afterend', wrap);
  }
})();
